<template>
    <div>
        <span
            :class="['hide-or-restore-icon', icon]"
            @click="hideOrRestoreCourse({ isHidden: isCourseHidden, id: course.id })"
            @keyup.enter="hideOrRestoreCourse({ isHidden: isCourseHidden, id: course.id })"
            v-tooltip="{ content: $t(tooltipText), html: true }"
            tabindex="0"
        >
        </span>
        <TotemToast ref="toast" :minWidth="230" />
    </div>
</template>

<script>
export default {
    name: 'totem-hide-or-restore-course',
    props: {
        course: {
            type: Object
        }
    },
    computed: {
        isCourseHidden () {
            return this.course.userMetadata && this.course.userMetadata.hiddenInUnfinishedCoursesList
        },
        icon () {
            return this.isCourseHidden ? 'icon-eye' : 'icon-eye-blocked'
        },
        tooltipText () {
            return this.isCourseHidden ? this.$t('UncompletedCourses.show_tooltip') : this.$t('UncompletedCourses.hide_tooltip')
        }
    },
    methods: {
        hideOrRestoreCourse (course) {
            course.isHidden ? this.restoreCourse(course.id) : this.hideCourse(course.id)
        },
        async restoreCourse (courseId) {
            await this.$store.dispatch('User/hideOrRestoreUncompletedCourseFromList', {
                courseId: courseId,
                isHidden: false
            })
            await this.$store.dispatch('VideoLog/loadCoursesForVideolog')
            await this.$store.dispatch('Courses/loadSignedUpEvents')
            this.$refs.toast.show(this.$t('UncompletedCourses.course_restored'))
        },
        async hideCourse (courseId) {
            this.$emit('hide-course', courseId)
        }
    }
}
</script>
